import { Component, OnInit, NgZone } from '@angular/core';
import {Router} from "@angular/router";
import {ApiService} from '../../services/api.service';
import { ModalController, NavController, LoadingController } from '@ionic/angular';
import { SchoolListPage } from '../school-list/school-list.page';

@Component({
  selector: 'app-login-sch',
  templateUrl: './login-sch.page.html',
  styleUrls: ['./login-sch.page.scss'],
})
export class LoginSchPage implements OnInit {

  rootPage:any;
  userID:any;
  isLoading = false;


  constructor(private router: Router,
              private api: ApiService,
              public modalCtrl: ModalController,
              private navCtrl: NavController,
              public loadingController: LoadingController,
              private zone: NgZone) { }

  ngOnInit() {
  		this.cekLogin();
  }

  cekLogin()
  {
    this.present();
  		var keyApp=localStorage.getItem('keyApp');
  		this.api.data('user/school?keyApp='+keyApp,'get','').subscribe(data=>{
  			this.loading=false;
  			this.onSuccess(data);  			
  		},error=>{
  			this.loading=false;
  		})
  }

  loading:boolean;
  login(id)
  {
  		this.loading=true;
  		this.api.data('user/school?uniqID='+id,'get','').subscribe(data=>{
  			this.loading=false;
  			this.onSuccess(data);  			
  		},error=>{
        alert(JSON.stringify(error));
  			this.loading=false;
        this.errorHandle(error.error);
  		})
  }
  msg:any='';
  errorHandle(data)
  {
    if(data=='KEY_NOT_EXIST')
    {
      this.msg='ID Sekolah tidak terdaftar';
      setTimeout(()=>{
        this.msg='';
      },3000);
    }
  }
  onSuccess(data)
  {
    localStorage.setItem('keyApp',data.keyApp);
    this.dismiss();
    this.navCtrl.navigateRoot(['/page/tabs/home']);
  }

    async schoolList() {
    const modal = await this.modalCtrl.create({
      component: SchoolListPage
    });
    return await modal.present();
  }

  async present() {
    this.isLoading = true;
    return await this.loadingController.create({
      spinner: 'crescent',
      duration: 3000,
      message: 'Tunggu Sebentar...',
      cssClass: 'custom-class custom-loading'
    }).then(a => {
      a.present().then(() => {
        console.log('presented');
        if (!this.isLoading) {
          a.dismiss().then(() => console.log('abort presenting'));
        }
      });
    });
  }

  async dismiss() {
    this.isLoading = false;
    return await this.loadingController.dismiss().then(() => console.log('dismissed'));
  }

}
